import React, { useState } from 'react'
import { Scrollama, Step } from 'react-scrollama'
import StageIntro from './StageIntro'
import '../styles/scroller-intro.scss'

const ScrollerIntro = () => {
  const [currentStepIndex, setCurrentStepIndex] = useState(-1)
  const [currentProgress, setCurrentProgress] = useState(null)

  // This callback fires when a Step hits the offset threshold. It receives the
  // data prop of the step, which in this demo stores the index of the step.
  const onStepEnter = ({ data }) => {
    setCurrentStepIndex(data)
  }

  const onStepProgress = ({ progress }) => {
    setCurrentProgress(progress)
  }
  const content = [
    'Higher education is the most direct path to economic mobility...',
    '...but this path is riddled with barriers for first-gen students...',
    '...and career services are not aligned to their needs.',
    'Fortunately, Basta has developed a proven method to accelerate first-gen students’ paths to great first jobs...',
    '...through sequencing and measuring the critical milestones of a job search.',
    'Using research, data, and our career diagnostic tool...',
    '...we discovered a critical through line connecting each principle: exposure',
    '',
    'Exposure — or the extent of a student’s understanding about different jobs and industries —',
    'is a critical concept we identify and measure.'
  ]

  return (
    <div className="container">
      <StageIntro step={currentStepIndex} progress={currentProgress} />
      <Scrollama
        onStepEnter={onStepEnter}
        onStepProgress={onStepProgress}
        offset={0.5}
        progress={true}
        //debug
      >
        {content.map((content, stepIndex) => (
          <Step data={stepIndex} key={stepIndex}>
            <article
              className={`intro ${stepIndex < 3 ? 'active' : null} ${
                stepIndex >= 3 && stepIndex === currentStepIndex
                  ? 'active'
                  : null
              }`}
            >
              {content}
            </article>
          </Step>
        ))}
      </Scrollama>
    </div>
  )
}

export default ScrollerIntro
